var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "span",
    {
      staticClass: "qp-link",
      attrs: {
        id: "qp-link",
        tabindex: _vm.disableAdaCompliance ? -1 : 0,
        "aria-label": "Zip logo",
        role: "button",
      },
    },
    [
      _vm.applyGrayLabel
        ? _c("span", { staticClass: "qp-powered-by" }, [_vm._v("powered by")])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "qp-logo",
          class: {
            "qp-logo--first": _vm.isLogoFirst,
            "qp-logo--last": !_vm.isLogoFirst,
            "qp-logo-gray-label--last": !_vm.isLogoFirst && _vm.applyGrayLabel,
          },
          style: _vm.logoAlignment ? { bottom: _vm.logoAlignment } : {},
          attrs: { id: "qp-logo" },
        },
        [
          _vm.hideLogo
            ? _c("span", [_vm._v("Zip")])
            : _vm.logoOption === "secondary"
            ? _c(
                "svg",
                {
                  attrs: {
                    id: "qp-logo-svg-secondary",
                    alt: "Zip logo, when clicked, opens infographic about the option of buying this item with 4 installment payments",
                    version: "1.1",
                    width: _vm.width,
                    height: _vm.height,
                    viewBox: "0 0 51 23",
                    xmlns: "http://www.w3.org/2000/svg",
                  },
                },
                [
                  _c("title", [_vm._v("Zip - Buy now pay later.")]),
                  _vm._v(" "),
                  _c("path", {
                    attrs: {
                      d: "M50.2002 3.58333C50.2002 1.74238 48.7079 0.25 46.8669 0.25H3.53353C1.69258 0.25 0.200195 1.74239 0.200195 3.58333V19.4167C0.200195 21.2577 1.69258 22.75 3.53353 22.75H46.8669C48.7079 22.75 50.2002 21.2577 50.2002 19.4167V3.58333Z",
                      fill: "#1A0826",
                    },
                  }),
                  _vm._v(" "),
                  _c("path", {
                    attrs: {
                      d: "M19.7075 8.00439L20.8545 17.3367H32.0708L30.9237 8.00439H19.7075Z",
                      fill: "#AA8FFF",
                    },
                  }),
                  _vm._v(" "),
                  _c("path", {
                    attrs: {
                      d: "M22.9072 4.44319C23.6225 5.11572 23.7207 6.17347 23.1264 6.80579C22.532 7.43811 21.4702 7.40549 20.7549 6.73297C20.0395 6.06046 19.9414 5.00271 20.5357 4.37039C21.13 3.73809 22.1919 3.77067 22.9072 4.44319Z",
                      fill: "#FFFFFA",
                    },
                  }),
                  _vm._v(" "),
                  _c("path", {
                    attrs: {
                      "fill-rule": "evenodd",
                      "clip-rule": "evenodd",
                      d: "M43.8252 11.3648C43.567 9.26594 41.9184 7.99706 39.6795 8.00443H32.2217L33.3687 17.3367H36.7252L36.4965 15.4702H40.0484C42.8404 15.4702 44.1202 13.7292 43.8252 11.3648ZM39.6832 12.855L36.1718 12.8587L35.8952 10.6197L39.425 10.6234C40.2549 10.6344 40.679 11.0992 40.7492 11.741C40.7934 12.1505 40.6052 12.855 39.6832 12.855Z",
                      fill: "#FFFFFA",
                    },
                  }),
                  _vm._v(" "),
                  _c("path", {
                    attrs: {
                      d: "M8.02638 14.7288L8.34726 17.3366H19.5524L19.1835 14.3525H13.9609L13.913 13.98L18.7262 10.6196L18.4054 8.00439H7.2002L7.56535 10.9922H12.7991L12.847 11.3647L8.02638 14.7288Z",
                      fill: "#FFFFFA",
                    },
                  }),
                ]
              )
            : _vm.logoOption === "secondary-light"
            ? _c(
                "svg",
                {
                  attrs: {
                    id: "qp-logo-svg-secondary-light",
                    alt: "Zip logo, when clicked, opens infographic about the option of buying this item with 4 installment payments",
                    version: "1.1",
                    width: _vm.width,
                    height: _vm.height,
                    viewBox: "0 0 51 23",
                    xmlns: "http://www.w3.org/2000/svg",
                  },
                },
                [
                  _c("title", [_vm._v("Zip - Buy now pay later.")]),
                  _vm._v(" "),
                  _c("path", {
                    attrs: {
                      d: "M46.7668 0.75C48.3316 0.75 49.6001 2.01852 49.6001 3.58333V19.4167C49.6001 20.9815 48.3316 22.25 46.7668 22.25H3.43343C1.86862 22.25 0.600098 20.9815 0.600098 19.4167V3.58333C0.600098 2.01853 1.86862 0.75 3.43343 0.75H46.7668Z",
                      fill: "#FFFFFA",
                      stroke: "#1A0826",
                    },
                  }),
                  _vm._v(" "),
                  _c("path", {
                    attrs: {
                      "fill-rule": "evenodd",
                      "clip-rule": "evenodd",
                      d: "M7.92575 14.7612L8.24585 17.3754H19.4508L19.0846 14.3819H13.8595L13.8143 14.0105L18.6261 10.6396L18.3046 8.01978H7.1001L7.46679 11.0137H12.6998L12.7459 11.3879L7.92575 14.7612Z",
                      fill: "#1A0826",
                    },
                  }),
                  _vm._v(" "),
                  _c("path", {
                    attrs: {
                      "fill-rule": "evenodd",
                      "clip-rule": "evenodd",
                      d: "M19.6064 8.01953L20.7522 17.3751H31.966L30.8198 8.01953H19.6064Z",
                      fill: "#AA8FFF",
                    },
                  }),
                  _vm._v(" "),
                  _c("path", {
                    attrs: {
                      "fill-rule": "evenodd",
                      "clip-rule": "evenodd",
                      d: "M20.6924 6.77815C21.4263 7.43263 22.4849 7.43263 23.0566 6.77815C23.6288 6.12368 23.4974 5.06231 22.7636 4.40783C22.0302 3.75289 20.9715 3.75289 20.3994 4.40783C19.8277 5.06231 19.9586 6.12368 20.6924 6.77815Z",
                      fill: "#1A0826",
                    },
                  }),
                  _vm._v(" "),
                  _c("path", {
                    attrs: {
                      "fill-rule": "evenodd",
                      "clip-rule": "evenodd",
                      d: "M39.5813 12.8811L36.0718 12.8849L35.7969 10.6397L39.3246 10.6426C40.154 10.6524 40.5789 11.1209 40.6474 11.7618C40.6912 12.1743 40.503 12.8811 39.5813 12.8811ZM43.7264 11.3881C43.4673 9.28501 41.8197 8.01062 39.5804 8.01945H32.1216L33.2673 17.3756H36.6226L36.3929 15.5042H39.9438C42.7386 15.5042 44.0176 13.758 43.7264 11.3881Z",
                      fill: "#1A0826",
                    },
                  }),
                ]
              )
            : _vm.logoOption === "black-white"
            ? _c(
                "svg",
                {
                  attrs: {
                    id: "qp-logo-svg-black-white",
                    alt: "Zip logo, when clicked, opens infographic about the option of buying this item with 4 installment payments",
                    version: "1.1",
                    width: _vm.width,
                    height: _vm.height,
                    viewBox: "0 0 50 19",
                    xmlns: "http://www.w3.org/2000/svg",
                  },
                },
                [
                  _c("title", [_vm._v("Zip - Buy now pay later.")]),
                  _vm._v(" "),
                  _c("path", {
                    attrs: {
                      "fill-rule": "evenodd",
                      "clip-rule": "evenodd",
                      d: "M1.12589 14.7881L1.56239 18.3528H16.8419L16.3425 14.2708H9.2174L9.15577 13.7644L15.7173 9.16761L15.2789 5.59518H0L0.50004 9.67786H7.63595L7.69885 10.1881L1.12589 14.7881Z",
                      fill: "black",
                    },
                  }),
                  _vm._v(" "),
                  _c("path", {
                    attrs: {
                      "fill-rule": "evenodd",
                      "clip-rule": "evenodd",
                      d: "M17.0544 5.59494L18.6168 18.3526H33.9084L32.3454 5.59494H17.0544Z",
                      fill: "black",
                    },
                  }),
                  _vm._v(" "),
                  _c("path", {
                    attrs: {
                      "fill-rule": "evenodd",
                      "clip-rule": "evenodd",
                      d: "M18.5351 3.90208C19.5358 4.79455 20.9794 4.79455 21.759 3.90208C22.5393 3.00961 22.3601 1.5623 21.3594 0.669829C20.3593 -0.223276 18.9157 -0.223276 18.1355 0.669829C17.3559 1.5623 17.5344 3.00961 18.5351 3.90208Z",
                      fill: "black",
                    },
                  }),
                  _vm._v(" "),
                  _c("path", {
                    attrs: {
                      "fill-rule": "evenodd",
                      "clip-rule": "evenodd",
                      d: "M44.2924 12.2244L39.5067 12.2295L39.1318 9.16798L43.9423 9.1718C45.0732 9.18518 45.6527 9.82411 45.7461 10.6981C45.8058 11.2606 45.5491 12.2244 44.2924 12.2244ZM49.9447 10.1885C49.5914 7.32061 47.3447 5.58281 44.2911 5.59485H34.12L35.6824 18.3532H40.2577L39.9445 15.8013H44.7867C48.5977 15.8013 50.3418 13.4201 49.9447 10.1885Z",
                      fill: "black",
                    },
                  }),
                ]
              )
            : _vm.logoOption === "dark-mode"
            ? _c(
                "svg",
                {
                  attrs: {
                    id: "qp-logo-svg",
                    alt: "Zip logo, when clicked, opens infographic about the option of buying this item with 4 installment payments",
                    version: "1.1",
                    width: _vm.width,
                    height: _vm.height,
                    viewBox: "0 0 300 111",
                    xmlns: "http://www.w3.org/2000/svg",
                  },
                },
                [
                  _c("title", [_vm._v("Zip - Buy now pay later.")]),
                  _vm._v(" "),
                  _c("path", {
                    attrs: {
                      "fill-rule": "evenodd",
                      "clip-rule": "evenodd",
                      d: "M6.75532 88.7283L9.37434 110.117H101.052L98.0551 85.6247H55.3044L54.9346 82.5861L94.3038 55.0056L91.6734 33.571H0L3.00024 58.0671H45.8157L46.1931 61.1286L6.75532 88.7283Z",
                      fill: "#ffffff",
                    },
                  }),
                  _vm._v(" "),
                  _c("path", {
                    attrs: {
                      "fill-rule": "evenodd",
                      "clip-rule": "evenodd",
                      d: "M102.326 33.5697L111.701 110.116H203.45L194.072 33.5697H102.326Z",
                      fill: "#AA8FFF",
                    },
                  }),
                  _vm._v(" "),
                  _c("path", {
                    attrs: {
                      "fill-rule": "evenodd",
                      "clip-rule": "evenodd",
                      d: "M111.211 23.4125C117.215 28.7673 125.877 28.7673 130.554 23.4125C135.236 18.0577 134.161 9.37379 128.156 4.01898C122.156 -1.33966 113.494 -1.33966 108.813 4.01898C104.135 9.37379 105.206 18.0577 111.211 23.4125Z",
                      fill: "#ffffff",
                    },
                  }),
                  _vm._v(" "),
                  _c("path", {
                    attrs: {
                      "fill-rule": "evenodd",
                      "clip-rule": "evenodd",
                      d: "M265.754 73.3464L237.04 73.377L234.791 55.0078L263.654 55.0307C270.44 55.111 273.916 58.9446 274.477 64.1886C274.835 67.5635 273.295 73.3464 265.754 73.3464ZM299.668 61.1309C297.549 43.9236 284.068 33.4968 265.747 33.5691H204.72L214.094 110.119H241.546L239.667 94.8077H268.72C291.586 94.8077 302.051 80.5206 299.668 61.1309Z",
                      fill: "#ffffff",
                    },
                  }),
                ]
              )
            : _c(
                "svg",
                {
                  attrs: {
                    id: "qp-logo-svg",
                    alt: "Zip logo, when clicked, opens infographic about the option of buying this item with 4 installment payments",
                    version: "1.1",
                    width: _vm.width,
                    height: _vm.height,
                    viewBox: "0 0 300 111",
                    xmlns: "http://www.w3.org/2000/svg",
                  },
                },
                [
                  _c("title", [_vm._v("Zip - Buy now pay later.")]),
                  _vm._v(" "),
                  _c("path", {
                    attrs: {
                      "fill-rule": "evenodd",
                      "clip-rule": "evenodd",
                      d: "M6.75532 88.7283L9.37434 110.117H101.052L98.0551 85.6247H55.3044L54.9346 82.5861L94.3038 55.0056L91.6734 33.571H0L3.00024 58.0671H45.8157L46.1931 61.1286L6.75532 88.7283Z",
                      fill: "#1A0826",
                    },
                  }),
                  _vm._v(" "),
                  _c("path", {
                    attrs: {
                      "fill-rule": "evenodd",
                      "clip-rule": "evenodd",
                      d: "M102.326 33.5697L111.701 110.116H203.45L194.072 33.5697H102.326Z",
                      fill: "#AA8FFF",
                    },
                  }),
                  _vm._v(" "),
                  _c("path", {
                    attrs: {
                      "fill-rule": "evenodd",
                      "clip-rule": "evenodd",
                      d: "M111.211 23.4125C117.215 28.7673 125.877 28.7673 130.554 23.4125C135.236 18.0577 134.161 9.37379 128.156 4.01898C122.156 -1.33966 113.494 -1.33966 108.813 4.01898C104.135 9.37379 105.206 18.0577 111.211 23.4125Z",
                      fill: "#1A0826",
                    },
                  }),
                  _vm._v(" "),
                  _c("path", {
                    attrs: {
                      "fill-rule": "evenodd",
                      "clip-rule": "evenodd",
                      d: "M265.754 73.3464L237.04 73.377L234.791 55.0078L263.654 55.0307C270.44 55.111 273.916 58.9446 274.477 64.1886C274.835 67.5635 273.295 73.3464 265.754 73.3464ZM299.668 61.1309C297.549 43.9236 284.068 33.4968 265.747 33.5691H204.72L214.094 110.119H241.546L239.667 94.8077H268.72C291.586 94.8077 302.051 80.5206 299.668 61.1309Z",
                      fill: "#1A0826",
                    },
                  }),
                ]
              ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }